import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

// restore the router query string when the user returns to this page
// (via Back to Listing link, eg)
export default function useLocationRestoration() {
  const location = useLocation();
  const history = useHistory();

  // restare the location data on page load if it's there
  useEffect(() => {
    const locationData = sessionStorage.getItem("locationData");

    if (locationData) {
      // defer the restoration so that it happens _after_ the setItem below
      window.requestAnimationFrame(() => {
        history.replace(JSON.parse(locationData));
      });
    }
  }, [history]);

  // record the router location in session storage
  useEffect(() => {
    sessionStorage.setItem("locationData", JSON.stringify(location));
  }, [location]);
}
